module.exports = __webpack_public_path__ + "media/images/price_list/reference-1-f1860cf5c26d9ce112ea27878e27ae07.webp";